import React from 'react';
import Slice from '../../../components-legacy/Slice';
import { IHeroSlice } from '../../slices/HeroSlice';
import { IProductSlice } from '../../slices/ProductSlice';

const sliceProcessor = (slices: ISlice[]) => {
  const nextSlices = Array.from(slices || []);

  for (let i = 0; i < nextSlices.length; i++) {
    const slice = nextSlices[i];
    const nextSlice = nextSlices?.[i + 1];

    if (slice.sliceType !== 'hero') {
      continue;
    }

    const heroSlice = slice as IHeroSlice;

    if (!heroSlice.connectToProductGrid || nextSlice?.sliceType !== 'product') {
      continue;
    }

    const productSlice = nextSlice as IProductSlice;

    heroSlice.productSlice = productSlice;

    nextSlices.splice(i + 1, 1);
  }

  return nextSlices;
};

interface IContentPage {
  body: ISlice[];
  loading: boolean;
  title: string;
}

const ContentPage = ({ body }: IContentPage) => {
  const slices = sliceProcessor(body);
  const headingIndex = slices.findIndex((s) => !!s.heading);

  return (
    <>
      {slices.map((slice, i) => (
        <Slice
          key={`${slice.sliceType}.${i}`}
          order={i}
          isHeadingSlice={i === headingIndex}
          {...slice}
        />
      ))}
    </>
  );
};

export default ContentPage;
